import React, { useContext } from 'react';
import StatusLabel from '../../../VentoryUI/components/common/StatusLabel/StatusLabel';
import { AssetUtil } from '../../../types/asset/asset.util';
import { Asset } from '../../../types/asset/asset';
import { AssetContext } from '../../../context/AssetContext';
import { AssetTransactionContext } from '../../../context/AssetTransactionContext';

interface AssetStatusLabel {
  asset: Asset;
}

export default function AssetStatusLabel({ asset }: AssetStatusLabel) {
  const { assets } = useContext(AssetContext);
  const { assetTransactions } = useContext(AssetTransactionContext);

  return (
    <StatusLabel
      color={AssetUtil.statusToColorStyle(asset, assets)}
      text={AssetUtil.statusToString(asset, assets, assetTransactions)}
    />
  );
}
